// extracted by mini-css-extract-plugin
export default {"Emoji":"bca_a bic_i bic_q bic_j"};